import React from 'react'
import { connect } from 'react-redux'
import {
  addShippingAddress,
  selectShippingAddress,
  deleteAddress,
  updateAddress,
  selectShippingAndBillingAddress,
  toggleUseBillingForShipping
} from './addressActionCreators'

import CheckoutAddressComponent from './CheckoutAddressComponent'

const mapShippingAddressStateToProps = (state) => {
  const e = state.entities;
  const c = state.constants;
  const useShippingForBilling = state.ui.useShippingForBilling;
  return {
    addresses: e.ShippingAddresses.map(
      id => e.Addresses.find((address) => address.Id === id)),
    selectedAddressId: e.SelectedShippingAddressId,
    addressType: c.ShippingAddressType,
    addressActionCreators: {
      add: addShippingAddress,
      remove: deleteAddress,
      select: useShippingForBilling ? selectShippingAndBillingAddress : selectShippingAddress,
      update: updateAddress
    },
    selectAddressMessage: useShippingForBilling ? "Bill and Ship to this address" : "Ship to this address",
    useForAnotherMessage: "Use shipping for billing address",
    useForAnotherSelected: useShippingForBilling,
    allowUseForAnother: state.constants.allowBillingEqualsShipping,
    sectionLabel: "Shipping Address",
    editable: false
  }
}

const mapShippingAddressDispatchToProps = dispatch => {
  return {
    onEndEdit: (Id) => dispatch(selectShippingAddress(Id)),
    onUseForAnotherClicked: () => dispatch(toggleUseBillingForShipping())
  }
}

const CheckoutShippingAddressContainer = connect(
  mapShippingAddressStateToProps,
  mapShippingAddressDispatchToProps
)(CheckoutAddressComponent);

export default CheckoutShippingAddressContainer;